import Box from '@mui/material/Box'
import { Outlet } from 'react-router-dom'
import * as React from 'react'
import { CssBaseline } from '@mui/material'
import SideBarTenant from './SideBarTenant'
import HeaderTenant from './HeaderTenant'

const drawerWidth = 250

const BaseTenant = () => {
  const [mobileMenu, setMobileMenu] = React.useState(false)

  const handleDrawerToggle = () => {
    setMobileMenu(!mobileMenu)
  }

  return (
    <Box sx={{ display: 'flex', overflow: 'hidden' }}>
      <CssBaseline/>
      <SideBarTenant mobileMenu={mobileMenu} handleDrawerToggle={handleDrawerToggle}/>
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          width: { md: `calc(100% - ${drawerWidth}px)` },
          overflow: 'auto',
          minHeight: '100%',
          paddingBottom: theme.spacing(10),
          [theme.breakpoints.up('lg')]: {
            paddingTop: theme.spacing(3),
          }
        })}
      >
        <HeaderTenant handleDrawerToggle={handleDrawerToggle}/>
        <Outlet/>
      </Box>
    </Box>
  )
}

export default BaseTenant
